import React from 'react';
import { Alert, Button, Modal } from 'antd';
import useKpiDeletionUsage from '@src/hooks/useKpiDeletionUsage';

const OverviewModal = ({
  primaryLabel,
  primaryMethod,
  secondaryLabel,
  secondaryMethod,
  isModalOpen,
  modalTitle,
  kpiId,
}) => {
  const { canDelete, usageWarning, isChecking, hasError, retry } = useKpiDeletionUsage(
    kpiId,
    isModalOpen,
  );
  const footerButtons = [
    <Button key="discard" onClick={secondaryMethod}>
      {secondaryLabel}
    </Button>,
    <Button
      key="save"
      type="primary"
      disabled={!canDelete}
      onClick={() => {
        if (canDelete) primaryMethod();
      }}
    >
      {primaryLabel}
    </Button>,
  ];

  return (
    <Modal
      width="500px"
      title="Delete Custom KPI"
      open={isModalOpen}
      onCancel={secondaryMethod}
      footer={footerButtons}
    >
      {hasError ? (
        <Alert
          type="error"
          showIcon
          message="Unable to check whether this KPI is used by AI Alerts. Please retry."
          action={<Button onClick={retry}>Retry</Button>}
        />
      ) : isChecking ? (
        <p role="status">Checking AI Alerts usage…</p>
      ) : usageWarning ? (
        <Alert type="warning" showIcon message={usageWarning} />
      ) : (
        modalTitle
      )}
    </Modal>
  );
};

export default OverviewModal;
